import React from "react";
import photoUrl from "../assets/img/treatments/SMP.JPEG";
import {
  smpPreCare,
  smpDays1to3,
  smpDays4to7,
  smpDays8to14,
  smpDay15Plus,
} from "../data/preCareInstructions";

const ScalpMicropigmentationCare = () => {
  return (
    <>
      <h1 className="md:text-5xl text-3xl justify-center flex my-8 m-auto p-2">
        Scalp Micropigmentation (SMP) Care
      </h1>

      <div className="flex flex-col-reverse md:mx-12 my-8 lg:flex-row flex-wrap items-start">
        <div className="w-full lg:w-3/5 pr-4 my-8 lg:mb-0">
          <div className="mb-6 p-8 ">
            <h2 className="md:text-3xl text-xl font-semibold mb-8 text-black">
              SMP Pre-Care & Post-Care Guide
            </h2>
            <p className="text-base leading-loose text-gray-800 lora-font">
              Scalp Micropigmentation is a specialized cosmetic procedure that requires 
              precise aftercare for optimal results. Following these guidelines ensures 
              proper healing, color retention, and the natural-looking appearance you desire. 
              Your commitment to proper care directly impacts the final results and longevity 
              of your SMP treatment.
            </p>
          </div>
        </div>
        <div className="w-full lg:w-2/5 p-4 md:p-0 md:pl-4 md:my-8 lg:mb-0">
          <img
            src={photoUrl}
            alt="Scalp Micropigmentation"
            className="rounded-lg shadow-lg w-[600px] h-[400px] object-cover mx-auto lg:mx-0"
          />
        </div>
      </div>

      {/* Pre-Care Section */}
      <div className="bg-gradient-to-r from-primary via-white to-primary md:mx-12 p-12 mt-8">
        <div className="bg-white p-8 shadow-lg">
          <div className="flex flex-col-reverse lg:flex-row flex-wrap items-start">
            <div className="w-full pr-4 mb-8 lg:mb-0">
              <div className="mb-6">
                <h2 className="text-4xl font-semibold mb-4 text-black">
                  SMP Pre-Care (Before Your Session)
                </h2>
                <p className="text-base leading-7 text-gray-800 mb-4">
                  To ensure the best results and smooth healing, please follow these simple steps before your appointment:
                </p>
                <ul className="list-disc list-inside leading-loose">
                  {smpPreCare.map((instruction, index) => (
                    <li key={index} className="mb-2">
                      {instruction}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Post-Care Timeline with modern card design */}
      <div className="bg-gray-50 py-12">
        <div className="container mx-auto px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl  text-gray-800 mb-4">Healing Timeline</h2>
            <p className="text-xl text-gray-600">Your Journey to Perfect Results</p>
            <div className="w-24 h-1 bg-primary mx-auto mt-4"></div>
          </div>

          {/* Cards Container with max width */}
          <div className="max-w-4xl mx-auto">
            {/* Days 1-3 */}
            <div className="mb-6">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
                <div style={{background: 'linear-gradient(to right, #b0c4b1, #e3d5ca)'}} className="p-3">
                  <h3 className="text-2xl font-bold text-gray-700 text-center">
                    Days 1–3
                  </h3>
                  <p className="text-gray-600 text-center text-sm mt-1">Keep it clean and dry</p>
                </div>
                <div className="p-5">
                  <ul className="space-y-2">
                    {smpDays1to3.map((instruction, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2"></div>
                        <p className="text-gray-700 text-base">{instruction}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>          {/* Days 4-7 */}
          <div className="mb-6">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
              <div style={{background: 'linear-gradient(to right, #e3d5ca, #ffe5ec)'}} className="p-3">
                <h3 className="text-2xl font-bold text-gray-700 text-center">
                  Days 4–7
                </h3>
                <p className="text-gray-600 text-center text-sm mt-1">Gentle care phase</p>
              </div>
              <div className="p-5">
                <ul className="space-y-2">
                  {smpDays4to7.map((instruction, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2"></div>
                      <p className="text-gray-700 text-base">{instruction}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Days 8-14 */}
          <div className="mb-6">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
              <div style={{background: 'linear-gradient(to right, #ffe5ec, #c9ada7)'}} className="p-3">
                <h3 className="text-2xl font-bold text-gray-700 text-center">
                  Days 8–14
                </h3>
                <p className="text-gray-600 text-center text-sm mt-1">Healing and balancing</p>
              </div>
              <div className="p-5">
                <ul className="space-y-2">
                  {smpDays8to14.map((instruction, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2"></div>
                      <p className="text-gray-700 text-base">{instruction}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Day 15+ */}
          <div className="mb-6">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
              <div style={{background: 'linear-gradient(to right, #c9ada7, #e0afa0)'}} className="p-3">
                <h3 className="text-2xl font-bold text-gray-700 text-center">
                  Day 15+
                </h3>
                <p className="text-gray-600 text-center text-sm mt-1">Long-term care</p>
              </div>
              <div className="p-5">
                <ul className="space-y-2">
                  {smpDay15Plus.map((instruction, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2"></div>
                      <p className="text-gray-700 text-base">{instruction}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

      {/* Final CTA Section */}
      <div className="bg-gradient-to-r from-primary via-white to-primary md:mx-12 p-12 mt-8">
        <div className="bg-white p-8 shadow-lg text-center">
          <h2 className="text-4xl font-bold mb-6 text-gray-800">Your SMP Journey Starts Here</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Following these care instructions ensures the best possible results for your 
            Scalp Micropigmentation treatment. Remember, patience during the healing process 
            leads to exceptional long-term results.
          </p>
          <div className="bg-gray-50 rounded-2xl p-8 max-w-2xl mx-auto border-l-4 border-primary">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Touch-Up Schedule</h3>
            <p className="text-gray-700">
              <strong>First touch-up:</strong> After 2 months<br/>
              <strong>Maintenance:</strong> Every 24 months as needed
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScalpMicropigmentationCare;